/* List of Redux constants */
export const CANDIDATE_LINK_SEARCH_ASSOCIATES_ACCOUNT_SET_ERROR_MESSAGE =
  '@candidate-link-search-associates-account/set-error-message';
export const CANDIDATE_LINK_SEARCH_ASSOCIATES_ACCOUNT_SET_LOADING =
  '@candidate-link-search-associates-account/set-loading';
export const CANDIDATE_LINK_SEARCH_ASSOCIATES_ACCOUNT_RESET_STATE =
  '@candidate-link-search-associates-account/reset-state';
export const CANDIDATE_LINK_SEARCH_ASSOCIATES_ACCOUNT_SET_SEARCH_ASSOCIATES_ACCOUNT_HAS_BEEN_LINKED =
  '@candidate-link-search-associates-account/set-search-associates-account-has-been-linked';

/* List of Sagas constants */
export const CANDIDATE_LINK_SEARCH_ASSOCIATES_ACCOUNT_LINK_ACCOUNT =
  '@candidate-link-search-associates-account/link-account';



// WEBPACK FOOTER //
// ./src/actions/candidate/candidate-link-search-associates-account/types.js